import constants from '../../settings/constants';
import InnerDropArea from '../InnerDropArea';
import Shelf from '../Shelf';
import geometry from '../util/geometry';

export default class IvarShelf extends Shelf {
  draw() {
    super.draw();
    this.interactive = !this.item.belongsTo;
  }

  drawDropAreas(slots) {
    const { scaledVertices } = this.data;

    this.dropAreas.x = 0;
    this.dropAreas.y = scaledVertices[0][1];

    super.drawDropAreas(slots);
  }

  getDropAreaSprite(localSlot) {
    const localItem = {
      ...this.item,
      x: 0,
      y: 0,
    };
    if (
      geometry.collides(localSlot, localItem, {
        top: 1,
      })
    ) {
      const sprite = new InnerDropArea({
        width: localSlot.width * this.ratio,
        height: localSlot.height * this.ratio,
        ratio: this.ratio,
        slot: localSlot,
        fullSize: true,
      });

      sprite.slot = localSlot;
      sprite.x = localSlot.x * this.ratio;

      return sprite;
    }
  }

  getSelfHitArea() {
    const { scaledVertices } = this.data;

    const padding = constants.DISTANCE_BETWEEN_ATTACHMENTS * this.ratio;

    const vertices = [
      [scaledVertices[0][0], scaledVertices[0][1] + padding],
      [scaledVertices[3][0], scaledVertices[3][1]],
      [scaledVertices[7][0], scaledVertices[7][1] - padding],
      [scaledVertices[6][0], scaledVertices[6][1] - padding],
      [scaledVertices[5][0], scaledVertices[5][1]],
      [scaledVertices[1][0], scaledVertices[1][1] + padding],
    ];

    return {
      regions: [vertices],
    };
  }

  sortChildren() {
    this.bottomContainer.children.sort((a, b) => a.item.x - b.item.x);
  }
}
